import React from 'react';
type ProductNameProps = {
  script?: boolean;
  accentClassName?: string;
};
export function ProductName({
  script = false,
  accentClassName = 'text-primary'
}: ProductNameProps) {
  return <>
      Barre Instructor{' '}
      {script ? <span className={`font-script text-[1.4em] font-normal leading-none ${accentClassName}`} data-id="element-289" data-mp="poi0ok5324v4">
          Ready
        </span> : <span className={`italic ${accentClassName}`} data-id="element-290" data-mp="1ia1f1akzfkeb">Ready</span>}
    </>;
}